import './styles/base.css';
import './styles/calculator.css';
import './styles/results-responsive.css';
import { mountCalculator } from './app';

const app = document.querySelector<HTMLDivElement>('#app');

if (!app) throw new Error('Missing #app root element.');

mountCalculator(app);

const requestedMarket = new URLSearchParams(window.location.search).get('market');
if (requestedMarket === 'PL') {
  const polishMarket = app.querySelector<HTMLInputElement>('input[data-action="market"][value="PL"]');
  if (polishMarket && !polishMarket.checked) polishMarket.click();
}
